export default "__VITE_ASSET__BHO7cfG6__"